import { useId } from 'react';

import Skeleton from 'react-loading-skeleton';

import styles from '@/components/Table/styles.module.scss';

export const SkeletonRow = ({ columnCount, columnWidths }: { columnCount: number; columnWidths?: number[] }) => {
  const id = useId();

  return (
    <tr className={styles.tableRow}>
      {Array(columnCount)
        .fill(0)
        .map((_, i) => (
          <td
            key={`skeleton-${id}-${i}`}
            className={styles.tableCell}
            style={{
              width: columnWidths ? columnWidths[i] : 'auto',
              padding: 16,
              borderTop: 'none',
            }}
          >
            <Skeleton height={16} />
          </td>
        ))}
    </tr>
  );
};
